import { Component, OnInit } from '@angular/core';

import {
  FormGroup,
  FormControl,
  FormArray,
  Validators,
  Form
} from '@angular/forms';

import Swal from 'sweetalert2/dist/sweetalert2.js';
import { FileItem, FileLikeObject, FileUploader } from 'ng2-file-upload';
import { IBanner } from 'src/app/interfaces/banner';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/appSettings';
import { ActivatedRoute, Router } from '@angular/router';
import { AppFormat } from 'src/app/appFormat';
import { BannersService } from 'src/app/services/banners.service';

@Component({
  selector: 'app-banners-register',
  templateUrl: './banners-register.component.html',
  styleUrls: ['./banners-register.component.scss'],
  host: { 'class': 'wrapper-settings' }
})
export class BannersRegisterComponent implements OnInit {

  // public local: string = null
  public local_slug: string = ''
  public title: string = ''

  public url_destiny: any[]
  public regions: any[]

  public banner: IBanner
  public loading: boolean = false

  public bannerFrm: FormGroup

  public dt_start: FormControl
  public dt_expired: FormControl
  public link_url: FormControl
  public target: FormControl
  public diasemana: FormControl
  public local: FormControl
  public local_ds: FormControl

  public diasemana_monday: FormControl
  public diasemana_tuesday: FormControl
  public diasemana_wednesday: FormControl
  public diasemana_thursday: FormControl
  public diasemana_friday: FormControl
  public diasemana_saturday: FormControl
  public diasemana_sunday: FormControl

  public showText: FormControl


  public publicado: FormControl
  public titulo: FormControl
  public acessibilidade: FormControl

  public select_program: FormControl

  public changed: boolean

  public image: string
  public image_mobile: string

  public uploader:FileUploader;
  public uploader_mobile:FileUploader;

  public num_uploads: number

  public hasBaseDropZoneOver:boolean = false;
  public hasBaseDropZoneOverMobile:boolean = false;

  constructor(private _apiService: ApiService, private _bannerService: BannersService, private _route: ActivatedRoute, private _router: Router) {
    /**
     *
     * envio da capa da vitrine
     *
     */

    this.uploader = new FileUploader({
      url: _apiService.API_PATH,
      allowedFileType: ['image'],
      allowedMimeType: [
        'image/jpeg',
        'image/png',
        'image/webp',
        'image/gif'
      ],
      maxFileSize: (1048576 * 5),
      filters: [{
        name: 'imageFilter',
        fn: function(item /*{File|FileLikeObject}*/, options) {
            var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
            return '|jpg|png|jpeg|gif|webp|'.indexOf(type) !== -1;
        }
      }]
    })

    this.uploader.onAfterAddingFile = f => {
      console.log(f)

      f.withCredentials = false;

      if (this.uploader.queue.length > 1) {
        this.uploader.removeFromQueue(this.uploader.queue[0]);
      }

      this.image = ''
      this.onChangeDetail()
    }

    this.uploader.onBeforeUploadItem = (fileItem: any) => {
        fileItem.options.additionalParameter = {
          idbanner: this.banner.idbanner,
          noreize: this.local.value == 'RT' && !this.showText.value ? 'N' : 'S',
        };
    }

    this.uploader.onCompleteItem = (item:any, response:any, status:number, headers:any) => {
      if (status == 200) {
        var responsePath = JSON.parse(response);
        if (responsePath['success']) {
          this.image = AppSettings.URL_IMG_ESTABELECIMENTO + this.banner.idestabelecimento + '/banners/' + this.banner.idbanner + '.png'
        }
      }
    }

    this.uploader.onCompleteAll = () => {
      this.uploader.clearQueue()
      this.num_uploads -= 1

      console.log('uploader', this.num_uploads)

      if (this.num_uploads <= 0) {
        this.saveComplete()
      }
    }

    this.uploader.onErrorItem = (item:FileItem, response:any, status:any, headers:any) => {
      //console.log(item)

      item.remove()

      Swal.fire("Ops!", "Ocorreu um erro ao processar a imagem, verifique se a imagem está correta! Se é um arquivo válido de imagem (png, jpg, webp, gif) com no máximo 2 MB de tamanho", "error")
    }

    this.uploader.onWhenAddingFileFailed = function (item: FileLikeObject, filter: any, options: any) {
      //console.log(item);
      //console.log(filter);
      //console.log(options);

      Swal.fire("Ops!", "O arquivo selecionado não é válido, verifique se é um arquivo de imagem (png, jpg, webp, gif) com no máximo 2 MB de tamanho!", "error")
    }


    this.uploader_mobile = new FileUploader({
      url: _apiService.API_PATH,
      allowedFileType: ['image'],
      allowedMimeType: [
        'image/jpeg',
        'image/png',
        'image/webp',
        'image/gif'
      ],
      maxFileSize: (1048576 * 2),
      filters: [{
        name: 'imageFilter',
        fn: function(item /*{File|FileLikeObject}*/, options) {
            var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
            return '|jpg|png|jpeg|gif|webp|'.indexOf(type) !== -1;
        }
      }]
    })

    this.uploader_mobile.onAfterAddingFile = f => {
      f.withCredentials = false;

      if (this.uploader_mobile.queue.length > 1) {
        this.uploader_mobile.removeFromQueue(this.uploader_mobile.queue[0]);
      }

      this.image_mobile = ''
      this.onChangeDetail()
    }

    this.uploader_mobile.onBeforeUploadItem = (fileItem: any) => {
        fileItem.options.additionalParameter = {
          idbanner: this.banner.idbanner,
          noreize: this.local.value == 'RT' && !this.showText.value ? 'N' : 'S',
          mobile: 'S'
        };
    }

    this.uploader_mobile.onCompleteItem = (item:any, response:any, status:number, headers:any) => {
      if (status == 200) {
        var responsePath = JSON.parse(response);
        if (responsePath['success']) {
          this.image_mobile = AppSettings.URL_IMG_ESTABELECIMENTO + this.banner.idestabelecimento + '/banners/' + this.banner.idbanner + '_mobile.png'
        }
      }
    }

    this.uploader_mobile.onCompleteAll = () => {
      this.uploader_mobile.clearQueue()
      this.num_uploads -= 1

      console.log('uploader_mobile', this.num_uploads)

      if (this.num_uploads <= 0) {
        this.saveComplete()
      }
    }

    this.uploader_mobile.onErrorItem = (item:FileItem, response:any, status:any, headers:any) => {
      //console.log(item)

      item.remove()

      Swal.fire("Ops!", "Ocorreu um erro ao processar a imagem, verifique se a imagem está correta! Se é um arquivo válido de imagem (png, jpg, webp, gif) com no máximo 2 MB de tamanho", "error")
    }

    this.uploader_mobile.onWhenAddingFileFailed = function (item: FileLikeObject, filter: any, options: any) {
      //console.log(item);
      //console.log(filter);
      //console.log(options);

      Swal.fire("Ops!", "O arquivo selecionado não é válido, verifique se é um arquivo de imagem (png, jpg, webp, gif) com no máximo 2 MB de tamanho!", "error")
    }
  }

  ngOnInit(): void {
    this.findRegions()

    this.url_destiny = [{
      value: 'N',
      label: 'Abrir na mesma janela do navegador'
    },{
      value: 'S',
      label: 'Abrir em outra aba do navegador'
    }]

    this.changed = false
    this.image = ''
    this.image_mobile = ''

    this.createFormControls()
    this.createForm()

    this.loading = true
    this._route.params.subscribe(data => {
      if (data['id'] !== undefined) {
        this.getBannerFromId(data['id'])
      } else {
        this.loading = false
      }
    })
  }

  findRegions() {
    this._bannerService.showRegions().subscribe(res => {
      if (res['success']) {
        this.regions = res['regions']
      }
    });
  }

  onClearRegion() {

  }

  toogleRegion() {
    let status = this.showText.value
    this.showText.setValue(!status)
  }

  createFormControls() {

    this.titulo = new FormControl(null)
    this.acessibilidade = new FormControl(null)
    this.publicado = new FormControl(false)
    this.diasemana = new FormControl(0)
    this.local = new FormControl('')
    this.local_ds = new FormControl('')

    this.diasemana_monday = new FormControl(false)
    this.diasemana_tuesday = new FormControl(false)
    this.diasemana_wednesday = new FormControl(false)
    this.diasemana_thursday = new FormControl(false)
    this.diasemana_friday = new FormControl(false)
    this.diasemana_saturday = new FormControl(false)
    this.diasemana_sunday = new FormControl(false)

    this.showText = new FormControl(false)

    this.target = new FormControl('S')
    this.link_url = new FormControl(null)

    this.dt_start = new FormControl(null)
    this.dt_expired = new FormControl(null)

    this.select_program = new FormControl('')

  }

  createForm() {
    this.bannerFrm = new FormGroup({
      titulo: this.titulo,
      acessibilidade: this.acessibilidade,
      publicado: this.publicado,
      diasemana: this.diasemana,
      target: this.target,
      link_url: this.link_url,
      dt_start: this.dt_start,
      dt_expired: this.dt_expired,
      select_program: this.select_program,
      diasemana_monday: this.diasemana_monday,
      diasemana_tuesday: this.diasemana_tuesday,
      diasemana_wednesday: this.diasemana_wednesday,
      diasemana_thursday: this.diasemana_thursday,
      diasemana_friday: this.diasemana_friday,
      diasemana_saturday: this.diasemana_saturday,
      diasemana_sunday: this.diasemana_sunday,
      local: this.local,
      local_ds: this.local_ds,
      showText: this.showText
    })
  }

  public fileOverBase(e:any):void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverBaseMobile(e:any):void {
    this.hasBaseDropZoneOverMobile = e;
  }

  isImage(file) {
    return file.type.indexOf('image')> -1
  }

  isVideo(file) {
    return file.type.indexOf('video')> -1
  }

  onChangeDetail() {
    this.changed = true
  }

  onChangeDays(ctl: FormControl) {
    this.diasemana_monday.setValue(false)
    this.diasemana_tuesday.setValue(false)
    this.diasemana_wednesday.setValue(false)
    this.diasemana_thursday.setValue(false)
    this.diasemana_friday.setValue(false)
    this.diasemana_saturday.setValue(false)
    this.diasemana_sunday.setValue(false)

    ctl.setValue(true)

    this.onChangeDetail()
  }

  getBannerFromId(id) {
    this.image = ''
    this.image_mobile = ''

    this.changed = false
    this._bannerService.show(id).subscribe(res => {
      if (res.idbanner) {

        this.loading = false

        this.banner = res

        this.local.setValue(res.local)
        this.titulo.setValue(res.titulo)
        this.acessibilidade.setValue(res.acessibilidade)
        this.link_url.setValue(res.link_url)
        this.target.setValue(res.target)

        this.diasemana.setValue(res.diasemana)
        if (res.diasemana > 0) {
          this.select_program.setValue('2')

          switch(res.diasemana) {
            case 1:
              this.diasemana_sunday.setValue(true)
              break;
            case 2:
              this.diasemana_monday.setValue(true)
              break;
            case 3:
              this.diasemana_tuesday.setValue(true)
              break;
            case 4:
              this.diasemana_wednesday.setValue(true)
              break;
            case 5:
              this.diasemana_thursday.setValue(true)
              break;
            case 6:
              this.diasemana_friday.setValue(true)
              break;
            case 7:
              this.diasemana_saturday.setValue(true)
              break;
          }
        }

        this.publicado.setValue(res.publicado == 'S')

        if (res.imagem != null) {
          this.image = res.imagem
        }

        if (res.imagem_mobile != null) {
          this.image_mobile = res.imagem_mobile
        }

        if (this.banner.dt_inicio && this.banner.dt_inicio != null) {
          let dtinicial = this.banner.dt_inicio.split(' ')
          this.dt_start.setValue(AppFormat.dateYMDUTCMoment(dtinicial[0]))
        }

        if (this.banner.dt_expiracao && this.banner.dt_expiracao != null) {
          let dt_expired = this.banner.dt_expiracao.split(' ')
          this.dt_expired.setValue(AppFormat.dateYMDUTCMoment(dt_expired[0]))
        }

        if (this.dt_start.value != null|| this.dt_expired.value != null) {
          this.select_program.setValue('1')
        }

      }
      this.loading = false
    })
  }

  onRemoveImage(tipo): void {

    let text = ''
    if (this.image != '' && this.publicado.value) {
      text = 'O banner será despublicado do site'
    }

    Swal.fire({
      title: 'Você deseja excluir a imagem do banner?',
      text: text,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false
    }).then((result) => {
      if (result.value) {

        if ((this.image != '' && tipo == '') || (this.image_mobile != '' && tipo == 'mobile')) {
        // if ((this.image != '' && tipo == '')) {

          Swal.fire({
            title: "Excluindo...",
            icon: "info",
            showCancelButton: false,
            allowOutsideClick: false,
            showConfirmButton: false,
            heightAuto: false
          })

            this._bannerService.removeImage(this.banner.idbanner, tipo).subscribe((res) => {
              if (tipo=='mobile'){
                this.image_mobile = ''
              } else {
                this.image = ''
              }

              this.publicado.setValue(false)

              Swal.fire({
                title: "Excluido!",
                icon: "success",
                text: "O banner foi excluido",
                showCancelButton: false,
                allowOutsideClick: true,
                showConfirmButton: true,
                heightAuto: false
              })

              this.onChangeDetail()
            })
        } else {
          if (tipo=='mobile'){
            this.uploader_mobile.removeFromQueue(this.uploader_mobile.queue[0]);
            this.uploader_mobile.clearQueue()
          } else {
            this.uploader.removeFromQueue(this.uploader.queue[0]);
            this.uploader.clearQueue()
          }
        }
      }
    })
  }

  onCancel() {
    Swal.fire({
      title: 'Você deseja cancelar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!'
    }).then((result) => {
      if (result.value) {
        this.loading = true
        this.getBannerFromId(this.banner.idbanner)
      }
    })
  }

  saveError() {
    Swal.fire("Ops!", "Ocorreu um erro ao tentar salvar.", "error")
  }

  saveComplete() {
    Swal.fire("Salvo!", "O banner foi salvo", "success")

    this.changed = false
  }

  saving() {
    Swal.fire({
      title: "Salvando...",
      icon: "info",
      showCancelButton: false,
      allowOutsideClick: false,
      showConfirmButton: false
    });
  }

  bannerValid() {
    let has = true

    let msg = []

    if (this.publicado.value && ((this.image == '' && (this.uploader.queue && this.uploader.queue.length == 0)) || (this.image_mobile == '' && (this.uploader_mobile.queue && this.uploader_mobile.queue.length == 0)))) {
    // if (this.publicado.value && ((this.image == '' && (this.uploader.queue && this.uploader.queue.length == 0)))) {
      msg.push('Para publicar é preciso da imagem do banner!');
      has = false
    }

    if (msg.length > 0) {
      Swal.fire("Ops!", msg.join("<br>"), "error");
    }

    return has
  }

  onSubmit() {
    if (this.bannerValid()) {

      let data = {
        publicado: this.publicado.value ? 'S' : 'N',
        titulo: this.titulo.value,
        acessibilidade: this.acessibilidade.value,
        link_url: this.link_url.value,
        target: this.target.value
      }

      if (this.showText.value) {
        data['local_ds'] = this.local_ds.value
      } else {
        data['local'] = this.local.value
      }

      data['diasemana'] = 0
      data['dt_inicio'] = ''
      data['dt_expiracao'] = ''

      if (this.select_program.value == 1) {
        let dtinicial = ''
        if (this.dt_start.value != null && typeof(this.dt_start.value) === 'object') {
          dtinicial = this.dt_start.value.format('YYYY-MM-DD');
        } else {
          dtinicial = this.dt_start.value
        }
        data['dt_inicio'] = dtinicial

        let dt_expiracao = ''
        if (this.dt_expired.value != null && typeof(this.dt_expired.value) === 'object') {
          dt_expiracao = this.dt_expired.value.format('YYYY-MM-DD');
        } else {
          dt_expiracao = this.dt_expired.value
        }
        data['dt_expiracao'] = dt_expiracao

      } else if (this.select_program.value == 2) {
        if (this.diasemana_monday.value) {
          data['diasemana'] = 2
        } else if (this.diasemana_tuesday.value) {
          data['diasemana'] = 3
        } else if (this.diasemana_wednesday.value) {
          data['diasemana'] = 4
        } else if (this.diasemana_thursday.value) {
          data['diasemana'] = 5
        } else if (this.diasemana_friday.value) {
          data['diasemana'] = 6
        } else if (this.diasemana_saturday.value) {
          data['diasemana'] = 7
        } else if (this.diasemana_sunday.value) {
          data['diasemana'] = 1
        }
      }

      this.saving()

      if (this.banner != null && this.banner.idbanner > 0) {
        this.patchShowcase(this.banner.idbanner, data)
      } else {
        this.storeShowcase(data)
      }
    }

    return null
  }

  storeShowcase(data) {
    this._bannerService.store(data).subscribe(res => {
      this.resShowcase(res)
    })
  }

  patchShowcase(id, data) {
    this._bannerService.patch(id, data).subscribe(res => {
      this.resShowcase(res)
    })
  }

  resShowcase(res) {

    if (res['success']) {

      this.num_uploads = 0
      this.banner = res['banner']
      if (this.uploader.queue.length > 0 || this.uploader_mobile.queue.length > 0) {
      // if (this.uploader.queue.length > 0) {

        if (this.uploader.queue.length > 0) {
          this.num_uploads += 1
        }

        if (this.uploader_mobile.queue.length > 0) {
          this.num_uploads += 1
        }

        this.sendImages()

      } else {
        this.saveComplete()
      }

    } else {
      this.saveError()
    }


  }

  sendImages(): void {
    this.uploader.setOptions({
      url: this._apiService.API_PATH + 'banner-rotative/' + this.banner.idbanner + '/image',
      authTokenHeader: "Authorization",
      authToken: "Bearer "+this._apiService.getAccessToken(),

    })

    this.uploader_mobile.setOptions({
      url: this._apiService.API_PATH + 'banner-rotative/' + this.banner.idbanner + '/image',
      authTokenHeader: "Authorization",
      authToken: "Bearer "+this._apiService.getAccessToken(),

    })

    this.uploader.uploadAll()
    this.uploader_mobile.uploadAll()
  }

}
